import React from 'react';
import { useSelector } from 'react-redux';
import copy from 'copy-to-clipboard';
import { Hide } from '@qga/roo-ui/components';
import { getPathName, getQueryString } from 'store/router/routerSelectors/routerGetters';
import { getProperty } from 'store/property/propertySelectors';
import { useDataLayer } from 'hooks/useDataLayer';
import SharePropertyTooltip from './SharePropertyTooltip';
import SharePropertyModal from './SharePropertyModal';
import head from 'lodash/head';
import { HOTELS_URL } from 'config/env';
import queryString from 'query-string';

const parseQueryString = (routeQueryString, source) =>
  queryString.stringify({
    ...queryString.parse(routeQueryString),
    utm_medium: 'referral',
    utm_source: source,
  });

const ShareProperty = () => {
  const pathName = useSelector(getPathName);
  const routeQueryString = useSelector(getQueryString);
  const { name: propertyName, id: propertyId, images } = useSelector(getProperty);
  const { emitInteractionEvent } = useDataLayer();
  const propertyUrl = `${HOTELS_URL}${pathName}`;
  const customAttributes = { user_event_value: propertyId };
  const eventType = 'Share Property';

  const sharePropertyProps = {
    propertyName,
    packshot: head(images),
    shareTypes: {
      facebook: {
        url: `${propertyUrl}?${parseQueryString(routeQueryString, 'facebook')}`,
        callback: () => {
          emitInteractionEvent({ type: eventType, value: 'Share property to Facebook', customAttributes });
        },
      },
      messenger: {
        url: `${propertyUrl}?${parseQueryString(routeQueryString, 'messenger')}`,
        callback: () => {
          emitInteractionEvent({ type: eventType, value: 'Share property to FB Messenger', customAttributes });
        },
      },
      whatsapp: {
        url: `${propertyUrl}?${parseQueryString(routeQueryString, 'whatsapp')}`,
        callback: () => {
          emitInteractionEvent({ type: eventType, value: 'Share property to Whatsapp', customAttributes });
        },
      },
      email: {
        url: encodeURIComponent(`${propertyUrl}?${parseQueryString(routeQueryString, 'email')}`),
        callback: () => {
          emitInteractionEvent({ type: eventType, value: 'Share property via Email', customAttributes });
        },
      },
      copyLink: {
        callback: () => {
          copy(propertyUrl);
          emitInteractionEvent({ type: eventType, value: 'Copy URL to clipboard', customAttributes });
        },
      },
    },
  };

  return (
    <>
      <Hide xs sm>
        <SharePropertyTooltip {...sharePropertyProps} />
      </Hide>
      <Hide md lg>
        <SharePropertyModal {...sharePropertyProps} />
      </Hide>
    </>
  );
};

export default ShareProperty;
